export function clamp(input: number, min: number, max: number): number {
    return Math.max(Math.min(input, max), min)
}

interface Point {
    x: number
    y: number
}

export function getDistance(point1: Point, point2: Point): number {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2))
}
